import { render, staticRenderFns } from "./BuildingFinancialTab.vue?vue&type=template&id=52181788"
import script from "./BuildingFinancialTab.vue?vue&type=script&lang=ts"
export * from "./BuildingFinancialTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports